/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MaskedInput/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import "DesignSystem/Fonts/Inter-400.css"
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MaskedInput({
  children,
  viewPath = "/DesignSystem/MaskedInput",
  backgroundColor = "#f2f2f2",
  borderBottomLeftRadius = 8,
  borderBottomRightRadius = 8,
  borderTopLeftRadius = 8,
  borderTopRightRadius = 8,
  autoComplete = "on",
  autoFocus,
  className,
  disabled,
  fontSize = 16,
  fontWeight = 300,
  marginLeft = 0,
  marginBottom = 0,
  marginTop = 0,
  marginRight = 0,
  onBlur,
  onChange,
  onFocus,
  onKeyUp,
  onCopy,
  onPaste,
  onSubmit,
  paddingBottom = 16,
  paddingLeft = 16,
  paddingRight = 16,
  paddingTop = 16,
  placeholder,
  width = 200,
  innerRef,
  textTransform = "capitalize",
  inputMode = "text",
  focusBackgroundColor = "rgba(0,206,124,0.1)",
  focusBorderColor = "rgba(0,206,124,0.7)",
  isInvalid,
  invalidBorderColor = "rgba(224,51,51, 0.75)",
  isDisabled
  
}) {
  return (<React.Fragment
>
<input
 type="text"
  data-testid="MaskedInput.Capture"
  data-view-path={viewPath}
 autoComplete={autoComplete}
 autoFocus={autoFocus}
 disabled={disabled}
 onBlur={onBlur}
 onChange={(e) => onChange && onChange(e, e.target.value)}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 onCopy={onCopy}
 onPaste={onPaste}
 onSubmit={onSubmit}
 placeholder={placeholder}
 ref={innerRef}
 inputMode={inputMode}
 style={{'--bc-1-Zo1G5V': backgroundColor,'--bblr-3-Zo1G5V': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-Zo1G5V': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-Zo1G5V': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-Zo1G5V': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--fs-7-Zo1G5V': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--fw-8-Zo1G5V': fontWeight,'--ml-9-Zo1G5V': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mb-10-Zo1G5V': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--mt-11-Zo1G5V': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-12-Zo1G5V': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--pb-13-Zo1G5V': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-14-Zo1G5V': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-15-Zo1G5V': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pt-16-Zo1G5V': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--w-17-Zo1G5V': typeof width === 'number' ? `${width}px` : width,'--tt-18-Zo1G5V': textTransform,'--bc-2-Zo1G5V': isInvalid ? invalidBorderColor : "transparent"}}
 className={`views-capture ${className} ${styles.Capture}`}
/>
{children}
</React.Fragment>)
}